import {
  FETCH_PLANS_BY_AMOUNT_LOADING,
  FETCH_PLANS_BY_AMOUNT_SUCCESS,
  FETCH_PLANS_BY_AMOUNT_FAILED,
} from "../types";

const initialState = {
  loading: false,
  plans: [],
  totalElements: 0,
  totalPages: 0,
  error: null,
};

const plansByAmountReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case FETCH_PLANS_BY_AMOUNT_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_PLANS_BY_AMOUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        plans: action.payload.content || [],
        totalElements: action.payload.totalElements || 0,
        totalPages: action.payload.totalPages || 0,
      };
    case FETCH_PLANS_BY_AMOUNT_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload || "Error fetching plans",
      };
    default:
      return state;
  }
};

export default plansByAmountReducer;
